import React, { useCallback } from 'react'
import styles from './TintDropdown.module.css'
import { t } from 'i18next'
import CustomDropdown from 'Components/CustomDropdown/CustomDropdown'

const TintDropdown = ({
  tints,
  isLoading,
  isError,
  onSelect,
  isSelected,
  shouldShow,
  selectedTints,
}) => {
  if (!shouldShow) return null

  if (isLoading) {
    return (
      <p className={`${styles.statusMessage} ${styles.fadeIn}`}>
        {t('TINT_SELECTOR.LOADING_MESSAGE')}
      </p>
    )
  }

  if (isError || tints?.length === 0) {
    return (
      <p className={`${styles.statusMessageError} ${styles.fadeIn}`}>
        {t('TINT_SELECTOR.ERROR_MESSAGE')}
      </p>
    )
  }

  const compareByVariantId = useCallback(
    (a, b) => a?.VariantDetailId === b?.VariantDetailId,
    []
  )

  return (
    <>
      <br />
      <p className={styles.title}>{t('TINT_SELECTOR.TITLE')}</p>
      <CustomDropdown
        multiple
        showSearch
        items={tints}
        displayKey="Name"
        onSelect={onSelect}
        searchKeys={['Name', 'Code']}
        selectedItem={selectedTints}
        wrapperStyle={{ height: '46.38px' }}
        placeholder={t('TINT_SELECTOR.PLACEHOLDER')}
        searchPlaceholder={t('TINT_SELECTOR.SEARCH_PLACEHOLDER')}
        compareItems={compareByVariantId}
        renderChip={item => (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <div
              style={{
                width: '16px',
                height: '16px',
                borderRadius: '3px',
                backgroundColor: item.Color,
                border: '1px solid #ddd',
                flexShrink: 0,
              }}
            />
            <span>{item.Name}</span>
            {item.Code && <span>{item.Code}</span>}
          </div>
        )}
        renderItem={item => (
          <div className={styles.tintOption}>
            <div
              className={styles.tintColorPreview}
              style={{ backgroundColor: item.Color }}
            />

            <span>
              {item.Name}{' '}
              <span className={styles.codeVariant}>{item.Code}</span>
            </span>

            <input
              readOnly
              type="radio"
              checked={isSelected(item)}
              className={styles.tintRadioButton}
            />
          </div>
        )}
      />
    </>
  )
}

export default TintDropdown
